import { render, staticRenderFns } from "./MultiselectGroup.vue?vue&type=template&id=5d749bf6"
import script from "./MultiselectGroup.vue?vue&type=script&lang=js"
export * from "./MultiselectGroup.vue?vue&type=script&lang=js"
import style0 from "./MultiselectGroup.vue?vue&type=style&index=0&id=5d749bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports